import { createContext } from "react";
import { serverUrl } from "@globalConfig";
export function factoryLocationContext(req) {
  var pathname = req.originalUrl.split('?')[0];
  var search = req.originalUrl.includes('?') ? req.originalUrl.split('?')[1] : '';
  var href = "".concat(serverUrl).concat(req.originalUrl);
  return {
    pathname: pathname,
    href: href,
    search: search ? "?".concat(search) : ''
  };
}
var LocationContext = /*#__PURE__*/createContext({});
export default LocationContext;